import { lazyLoad } from 'utils/loadable';

export const OptimizelyFlagsLoadable = lazyLoad(
  () => import('./OptimizelyFlags'),
  module => module.OptimizelyFlags,
);
